(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["djzone-accessibility"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    var KEY = 'dz-a11y-v1';
    var TOGGLES = ['contrast', 'invert', 'mono', 'links', 'headings', 'readable', 'spacing', 'cursor', 'motion'];
    var STEPS = [90, 100, 112, 125, 140, 160];
    var wrap = document.querySelector('.dz-a11y');
    if (!wrap) return;
    var toggle = wrap.querySelector('#dz-a11y-toggle');
    var panel = wrap.querySelector('#dz-a11y-panel');
    var value = wrap.querySelector('#dz-a11y-font-value');
    var state = { font: 1, on: {} };

    function read() {
      try {
        var raw = localStorage.getItem(KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (typeof parsed.font === 'number') state.font = parsed.font;
          if (parsed.on && typeof parsed.on === 'object') state.on = parsed.on;
        }
      } catch (e) { /* storage blocked — run with defaults */ }
    }
    function save() {
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
    }
    function apply() {
      var pct = STEPS[state.font] || 100;
      root.style.fontSize = pct === 100 ? '' : pct + '%';
      if (value) value.textContent = pct + '%';
      TOGGLES.forEach(function (name) {
        var active = !!state.on[name];
        root.classList.toggle('dz-a11y-' + name, active);
        var btn = wrap.querySelector('[data-dz-a11y="' + name + '"]');
        if (btn) btn.setAttribute('aria-pressed', String(active));
      });
    }
    function openPanel(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        var first = panel.querySelector('button');
        if (first) first.focus();
      }
    }

    toggle.addEventListener('click', function () { openPanel(panel.hidden); });
    var closeBtn = wrap.querySelector('.dz-a11y__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { openPanel(false); toggle.focus(); });

    wrap.addEventListener('click', function (event) {
      var target = event.target.closest('[data-dz-a11y]');
      if (!target) return;
      var action = target.getAttribute('data-dz-a11y');
      if (action === 'font-up') state.font = Math.min(STEPS.length - 1, state.font + 1);
      else if (action === 'font-down') state.font = Math.max(0, state.font - 1);
      else if (action === 'reset') { state = { font: 1, on: {} }; }
      else state.on[action] = !state.on[action];
      apply();
      save();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) { openPanel(false); toggle.focus(); }
    });
    document.addEventListener('click', function (event) {
      if (panel.hidden) return;
      if (!wrap.contains(event.target)) openPanel(false);
    });

    read();
    apply();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["djzone-ai-config"] && !Shopify.designMode) return;
  try {
    (function () {
    var verdictEl = document.getElementById('dz-compare-verdict');
    if (!verdictEl) return;

    var config = window.DZ_AI || {};
    if (!config.endpoint) return;

    function handles() {
      var shared = new URLSearchParams(location.search).get('p');
      if (shared) return shared.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 4);
      try {
        return (JSON.parse(localStorage.getItem('dz-compare-v1')) || [])
          .map(function (entry) { return entry.handle; }).slice(0, 4);
      } catch (e) { return []; }
    }

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }

    function showLoading() {
      var box = el('div', 'dz-verdict');
      var head = el('div', 'dz-verdict__head');
      head.appendChild(el('h3', null, 'מה באמת ההבדל ביניהם?'));
      head.appendChild(el('span', 'dz-verdict__badge', 'היועץ של DJzone'));
      box.appendChild(head);
      var loading = el('div', 'dz-verdict__loading');
      loading.appendChild(document.createTextNode('היועץ קורא את המפרטים ומשווה'));
      loading.appendChild(el('i'));
      loading.appendChild(el('i'));
      loading.appendChild(el('i'));
      box.appendChild(loading);
      verdictEl.innerHTML = '';
      verdictEl.appendChild(box);
    }

    function render(verdict, products) {
      var box = el('div', 'dz-verdict');

      var head = el('div', 'dz-verdict__head');
      head.appendChild(el('h3', null, 'מה באמת ההבדל ביניהם?'));
      head.appendChild(el('span', 'dz-verdict__badge', 'היועץ של DJzone'));
      box.appendChild(head);

      if (verdict.headline) box.appendChild(el('p', 'dz-verdict__lead', verdict.headline));

      var byHandle = {};
      products.forEach(function (product) { byHandle[product.handle] = product; });

      var cards = el('div', 'dz-verdict__cards');
      (verdict.products || []).forEach(function (entry) {
        var product = byHandle[entry.handle];
        var card = el('div', 'dz-verdict__card');
        card.appendChild(el('h4', null, product ? product.title : entry.handle));
        if (entry.best_for) card.appendChild(el('p', 'dz-verdict__for', entry.best_for));
        var list = el('ul');
        (entry.strengths || []).forEach(function (line) { list.appendChild(el('li', null, line)); });
        (entry.tradeoffs || []).forEach(function (line) { list.appendChild(el('li', 'is-trade', '↓ ' + line)); });
        if (list.children.length) card.appendChild(list);
        cards.appendChild(card);
      });
      if (cards.children.length) box.appendChild(cards);

      if ((verdict.deciding_questions || []).length) {
        var ask = el('p', 'dz-verdict__ask');
        ask.appendChild(el('b', null, 'שאלו את עצמכם: '));
        ask.appendChild(document.createTextNode(verdict.deciding_questions.join(' · ')));
        box.appendChild(ask);
      }

      if (verdict.bottom_line) box.appendChild(el('p', 'dz-verdict__bottom', verdict.bottom_line));

      box.appendChild(el('p', 'dz-verdict__note',
        'הניתוח נכתב אוטומטית על סמך המפרט והתיאורים באתר. לא בטוחים? שאלו את היועץ או השאירו פנייה.'));

      verdictEl.innerHTML = '';
      verdictEl.appendChild(box);
    }

    function run() {
      var wanted = handles();
      if (wanted.length < 2) return;

      var computed = verdictEl.innerHTML; // keep the table's own summary as the fallback
      showLoading();

      Promise.all(wanted.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      })).then(function (loaded) {
        var products = loaded.filter(Boolean);
        if (products.length < 2) { verdictEl.innerHTML = computed; return; }

        return fetch(config.endpoint.replace(/\/$/, '') + '/api/compare', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            products: products.map(function (product) {
              return {
                handle: product.handle,
                title: product.title,
                vendor: product.vendor,
                type: product.type,
                price: product.price,
                available: product.available,
                description: product.description
              };
            })
          })
        }).then(function (response) {
          if (!response.ok) throw new Error('status ' + response.status);
          return response.json();
        }).then(function (verdict) {
          render(verdict, products);
        });
      }).catch(function () {
        verdictEl.innerHTML = computed; // service down or not configured yet
      });
    }

    /* The section fills #dz-compare-verdict client side, so wait for it rather
       than racing it. */
    var tries = 0;
    (function waitForTable() {
      var ready = !document.getElementById('dz-compare-result').hidden;
      if (ready) { run(); return; }
      if (++tries > 40) return;
      setTimeout(waitForTable, 250);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["djzone-assistant"] && !Shopify.designMode) return;
  try {
    (function () {
    var toggle = document.getElementById('dz-assistant-toggle');
    var panel = document.getElementById('dz-assistant-panel');
    if (!toggle || !panel) return;

    var log = document.getElementById('dz-assistant-log');
    var chipsEl = document.getElementById('dz-assistant-chips');
    var form = document.getElementById('dz-assistant-form');
    var input = document.getElementById('dz-assistant-input');
    var sendBtn = document.getElementById('dz-assistant-send');
    var statusEl = document.getElementById('dz-assistant-status');
    var bubble = document.getElementById('dz-assistant-bubble');
    var config = window.DZ_AI || {};
    var history = [];
    var busy = false;

    var LINKS = {
      shipping: '/pages/shipping-returns',
      terms: '/pages/terms',
      privacy: '/pages/privacy',
      a11y: '/pages/accessibility',
      contact: config.contactUrl || '/pages/contact',
      compare: '/pages/compare',
      waze: 'https://waze.com/ul?ll=32.1140776,34.9037021&navigate=yes'
    };
    function collection(name) { return '/collections/' + encodeURIComponent(name); }

    /* ---------------------------------------------------------------
       Greeting bubble. Shown on every page of a visit until the visitor
       closes it or opens the advisor; after that it stays away for the visit.
       --------------------------------------------------------------- */
    var BUBBLE_KEY = 'dz-assistant-greeted';
    function bubbleDone() {
      try { return sessionStorage.getItem(BUBBLE_KEY) === '1'; } catch (e) { return false; }
    }
    function hideBubble() {
      if (!bubble || bubble.hidden) return;
      try { sessionStorage.setItem(BUBBLE_KEY, '1'); } catch (e) { /* storage blocked */ }
      bubble.classList.remove('is-visible');
      setTimeout(function () { bubble.hidden = true; }, 300);
    }
    if (bubble && !bubbleDone()) {
      setTimeout(function () {
        if (!panel.hidden || bubbleDone()) return;
        bubble.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { bubble.classList.add('is-visible'); }); });
      }, 1200);
      document.getElementById('dz-assistant-bubble-open').addEventListener('click', function () { open(); });
      document.getElementById('dz-assistant-bubble-close').addEventListener('click', hideBubble);
    }

    /* ---------------------------------------------------------------
       Rendering. Replies come back as plain text with markdown links, so
       everything is escaped first and only links and bold are re-introduced.
       --------------------------------------------------------------- */
    function escapeHtml(text) {
      return String(text).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }
    function richText(text) {
      return escapeHtml(text)
        .replace(/\[([^\]]{1,120})\]\((\/[^)\s]{1,200}|https:\/\/[^)\s]{1,200})\)/g,
          function (_, label, href) { return '<a href="' + href + '">' + label + '</a>'; })
        .replace(/\*\*([^*\n]{1,120})\*\*/g, '<strong>$1</strong>');
    }

    function scroll() { log.scrollTop = log.scrollHeight; }

    function bubbleMsg(who) {
      var msg = document.createElement('div');
      msg.className = 'dz-assistant__msg dz-assistant__msg--' + who;
      log.appendChild(msg);
      scroll();
      return msg;
    }

    function say(html, who) {
      var msg = bubbleMsg(who || 'bot');
      msg.innerHTML = html;
      scroll();
      return msg;
    }

    function typingInto(msg) {
      msg.innerHTML = '<span class="dz-assistant__dots"><i></i><i></i><i></i></span>';
      return msg;
    }

    function chips(items) {
      chipsEl.innerHTML = '';
      items.forEach(function (label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.addEventListener('click', function () { if (!busy) send(label); });
        chipsEl.appendChild(button);
      });
    }

    var DEFAULT_CHIPS = ['רמקול לאירוע', 'קונטרולר לדי ג׳יי', 'תאורה לאירוע', 'ציוד אולפן', 'משלוחים', 'השכרה'];

    function money(cents) {
      return '₪' + (cents / 100).toLocaleString('he-IL', { maximumFractionDigits: 0 });
    }

    function productCards(hits, holder) {
      if (!hits.length) return;
      var wrap = document.createElement('div');
      wrap.style.marginTop = '4px';
      hits.slice(0, 4).forEach(function (hit) {
        var card = document.createElement('a');
        card.className = 'dz-assistant__hit';
        card.href = hit.url;
        var image = document.createElement('img');
        image.src = hit.image || '';
        image.alt = '';
        image.loading = 'lazy';
        var text = document.createElement('div');
        var name = document.createElement('b');
        name.textContent = hit.title;
        var tag = document.createElement('i');
        tag.textContent = hit.available ? money(hit.price) : 'אזל מהמלאי';
        text.appendChild(name);
        text.appendChild(tag);
        card.appendChild(image);
        card.appendChild(text);
        wrap.appendChild(card);
      });
      holder.appendChild(wrap);
      scroll();
    }

    /* Catalogue lookup. /search/suggest.json answers "Unsupported buyer locale"
       on a Hebrew-only shop, so results come from our own section instead. */
    function lookup(query) {
      return fetch('/search?q=' + encodeURIComponent(query) + '&type=product&section_id=djzone-search-json')
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var start = text.indexOf('{');
          var end = text.lastIndexOf('}');
          if (start === -1 || end <= start) return [];
          return JSON.parse(text.slice(start, end + 1)).products || [];
        })
        .catch(function () { return []; });
    }

    /* ---------------------------------------------------------------
       The AI path: stream the reply from our own service, which holds the
       API key. Rejects on any failure so the caller can fall back.
       --------------------------------------------------------------- */
    function askAI(catalog, holder) {
      if (!config.endpoint) return Promise.reject(new Error('no endpoint'));

      return fetch(config.endpoint.replace(/\/$/, '') + '/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history, catalog: catalog })
      }).then(function (response) {
        if (!response.ok || !response.body) throw new Error('status ' + response.status);

        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';
        var answer = '';
        var started = false;

        function pump() {
          return reader.read().then(function (chunk) {
            if (chunk.done) return answer;
            buffer += decoder.decode(chunk.value, { stream: true });

            var parts = buffer.split('\n\n');
            buffer = parts.pop();
            parts.forEach(function (part) {
              var line = part.trim();
              if (line.indexOf('data: ') !== 0) return;
              var payload = line.slice(6);
              if (payload === '[DONE]') return;
              try {
                var event = JSON.parse(payload);
                if (typeof event.t !== 'string') return;
                answer += event.t;
                if (!started) { started = true; holder.innerHTML = ''; }
                holder.innerHTML = richText(answer);
                scroll();
              } catch (e) { /* ignore a partial frame */ }
            });
            return pump();
          });
        }

        return pump().then(function (text) {
          if (!text.trim()) throw new Error('empty reply');
          return text;
        });
      });
    }

    /* ---------------------------------------------------------------
       Fallback: the fixed knowledge base. Each answer links to the page that
       holds the binding text, so it can never contradict the policies.
       --------------------------------------------------------------- */
    var TOPICS = [
      { test: /(משלוח|שילוח|שליח|דואר|מתי יגיע|כמה זמן לוקח|איסוף עצמי)/,
        reply: 'אנחנו שולחים לכל הארץ, ואפשר גם לתאם איסוף עצמי מהחנות. זמני האספקה, דמי המשלוח ותנאי האיסוף מפורטים בעמוד <a href="' + LINKS.shipping + '">משלוחים והחזרות</a>.' },
      { test: /(החזר|החלפה|ביטול עסקה|זיכוי|לא מתאים לי)/,
        reply: 'אפשר לבטל עסקה ולהחזיר מוצר בהתאם לחוק הגנת הצרכן. כל התנאים והחריגים נמצאים בעמוד <a href="' + LINKS.shipping + '">משלוחים והחזרות</a>, ובהרחבה ב<a href="' + LINKS.terms + '">תקנון</a>.' },
      { test: /(אחריות|תקלה|התקלקל|תיקון|מעבדה)/,
        reply: 'כל המוצרים מגיעים עם אחריות יבואן רשמי. אם משהו לא עובד — <a href="' + LINKS.contact + '">השאירו פנייה</a> עם דגם המוצר ותיאור התקלה, ונכוון אתכם. פרטי האחריות ב<a href="' + LINKS.terms + '">תקנון</a>.' },
      { test: /(תשלום|אשראי|ביט|תשלומים|חשבונית|מע"?מ|מעמ)/,
        reply: 'התשלום באתר מאובטח בכרטיס אשראי, והמחירים כוללים מע״מ. לתשלום בהעברה בנקאית או לפריסת תשלומים — <a href="' + LINKS.contact + '">דברו איתנו</a>.' },
      { test: /(השכר|להשכיר|שכירות|אירוע חד פעמי|הפקה)/,
        reply: 'יש לנו מערך השכרה מלא של הגברה ותאורה לאירועים, כולל התקנה והפעלה. <a href="' + collection('השכרת-הגברה-ותאורה') + '">לפרטי ההשכרה</a>.' },
      { test: /(מלאי|במלאי|זמין|אזל)/,
        reply: 'הזמינות מוצגת בעמוד המוצר עצמו. אם משהו מסומן כאזל — <a href="' + LINKS.contact + '">כתבו לנו</a> את שם הדגם, לרוב יש לנו אותו במלאי החנות או בהזמנה קצרה.' },
      { test: /(כתובת|חנות|איפה אתם|איך מגיעים|להגיע|ניווט|וויז|waze|מפה|שעות|פתוח|טלפון|מייל|ליצור קשר|צור קשר)/i,
        reply: 'אנחנו בנתן שיפריס 3, פתח תקווה — הגעה בתיאום מראש בלבד. שעות פעילות: א׳–ה׳ 9:00–21:00, ו׳ 9:00–15:00. איש קשר: אביעד לדר, טלפון 052-8091233, דוא״ל djzonestore@gmail.com. <a href="' + LINKS.waze + '" target="_blank" rel="noopener">ניווט ב־Waze</a> · <a href="' + LINKS.contact + '">מפה וטופס יצירת קשר</a>.' },
      { test: /(נגישות|מוגבלות|קורא מסך|ניגודיות)/,
        reply: 'האתר נבנה לפי תקן הנגישות הישראלי, ויש כפתור נגישות צף בפינת המסך. ההצהרה המלאה ב<a href="' + LINKS.a11y + '">הצהרת נגישות</a>.' },
      { test: /(פרטיות|מידע אישי|עוגיות|cookies|דיוור)/,
        reply: 'מה אנחנו אוספים, למה, ואיך מוחקים — הכול ב<a href="' + LINKS.privacy + '">מדיניות הפרטיות</a>.' },
      { test: /(להשוות|השווא|הבדל בין|מה עדיף|איזה יותר טוב)/,
        reply: 'בכל כרטיס מוצר בקטלוג יש כפתור <b>״השוואה״</b>. סמנו 2–4 מוצרים ותקבלו טבלה שמראה במה הם נבדלים. <a href="' + LINKS.compare + '">למסך ההשוואה</a>.' }
    ];

    var GUIDES = [
      { chip: 'רמקול לאירוע', ask: /(אירוע|חתונה|מסיבה|בר מצווה|רמקול|הגברה|סאונד)/,
        reply: 'כדי להתאים הגברה צריך לדעת שני דברים: כמה אנשים, ואם זה בחוץ או בפנים.' +
          '<ul><li>עד 80 איש בפנים — זוג רמקולים מוגברים 12״ מספיק.</li>' +
          '<li>80–250 איש — זוג 15״ מוגברים בתוספת סאבוופר.</li>' +
          '<li>מעל 250 איש או בחוץ — מערכת עם סאב כפול.</li></ul>' +
          '<a href="' + collection('רמקולים') + '">לכל הרמקולים</a>' },
      { chip: 'קונטרולר לדי ג׳יי', ask: /(קונטרולר|controller|דיג|די ג|מתחיל|ללמוד|serato|rekordbox)/,
        reply: 'למתחילים — קונטרולר 2 ערוצים עם כרטיס קול מובנה ותוכנה בחבילה. למי שמנגן באירועים — 4 ערוצים ומסכים על הדק. ' +
          '<a href="' + collection('קונטרולרים') + '">לכל הקונטרולרים</a>' },
      { chip: 'תאורה לאירוע', ask: /(תאורה|פנס|לד|led|אפקט|לייזר|מוביל)/,
        reply: 'תאורה בונים בשכבות: פנסי צבע לרחבה, אפקט אחד או שניים לתנועה, ופנסים חכמים לתוכנית מסונכרנת. ' +
          '<a href="' + collection('תאורה') + '">לכל התאורה</a>' },
      { chip: 'ציוד אולפן', ask: /(אולפן|הקלט|פודקאסט|מיקרופון|studio|אוזניות)/,
        reply: 'לאולפן ביתי או פודקאסט צריך שלושה דברים: מיקרופון, כרטיס קול ואוזניות סגורות לניטור. ' +
          '<a href="' + collection('ציוד-אולפני') + '">ציוד אולפני</a>' },
      { chip: 'כבלים וסטנדים', ask: /(כבל|מחבר|xlr|jack|סטנד|חצובה|קייס|תיק)/,
        reply: 'החלק שתמיד שוכחים. <a href="' + collection('כבלים-ומחברים') + '">כבלים ומחברים</a> · <a href="' + collection('סטנדים') + '">סטנדים</a>' }
    ];

    function fallbackAnswer(question, hits, holder) {
      var topic = TOPICS.find(function (entry) { return entry.test.test(question); });
      if (topic) { holder.innerHTML = topic.reply; scroll(); return; }

      var guide = GUIDES.find(function (entry) { return entry.chip === question || entry.ask.test(question); });
      if (guide) {
        holder.innerHTML = guide.reply;
      } else if (hits.length) {
        holder.innerHTML = 'הנה מה שמצאתי בקטלוג שמתאים לחיפוש שלכם:';
      } else {
        holder.innerHTML = 'לא הצלחתי לענות על זה לבד. <a href="' + LINKS.contact +
          '">השאירו לנו פנייה</a> ונחזור אליכם, או התקשרו ל־052-8091233.';
      }
      scroll();
    }

    /* --------------------------------------------------------------- */

    function send(question) {
      var clean = String(question || '').trim();
      if (!clean || busy) return;

      busy = true;
      sendBtn.disabled = true;
      input.value = '';
      chipsEl.innerHTML = '';

      say(escapeHtml(clean), 'me');
      history.push({ role: 'user', content: clean });

      var holder = typingInto(bubbleMsg('bot'));
      statusEl.textContent = 'חושב…';

      lookup(clean).then(function (hits) {
        return askAI(hits, holder)
          .then(function (answer) {
            history.push({ role: 'assistant', content: answer });
            productCards(hits, holder);
          })
          .catch(function () {
            // Service unavailable or not configured — answer locally instead.
            history.pop();
            fallbackAnswer(clean, hits, holder);
            productCards(hits, holder);
          });
      }).then(function () {
        busy = false;
        sendBtn.disabled = false;
        statusEl.textContent = 'כאן כדי לעזור לכם לבחור';
        chips(DEFAULT_CHIPS);
        if (history.length > 24) history = history.slice(-16);
      });
    }

    var started = false;
    function open() {
      hideBubble();
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (!started) {
        started = true;
        say('היי 👋 אני היועץ של DJzone. ספרו לי מה אתם מחפשים — לאיזה אירוע, כמה אנשים, מה התקציב — ואני אעזור לכם להתאים את הציוד הנכון.');
        chips(DEFAULT_CHIPS);
      }
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
    document.getElementById('dz-assistant-close').addEventListener('click', close);
    form.addEventListener('submit', function (event) { event.preventDefault(); send(input.value); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !panel.hidden) close(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["djzone-compare"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'dz-compare-v1';
    var MAX = 4;
    var tray = document.getElementById('dz-cmp-tray');
    if (!tray) return;
    var itemsEl = document.getElementById('dz-cmp-items');
    var countEl = document.getElementById('dz-cmp-count');
    var clearEl = document.getElementById('dz-cmp-clear');

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
      render();
      syncToggles();
    }
    function handleFromHref(href) {
      var match = String(href || '').match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    }

    function render() {
      var list = read();
      countEl.textContent = String(list.length);
      tray.hidden = list.length === 0;
      document.body.classList.toggle('dz-cmp-open', list.length > 0);
      itemsEl.innerHTML = '';
      list.forEach(function (item) {
        var chip = document.createElement('div');
        chip.className = 'dz-cmp-chip';
        var img = document.createElement('img');
        img.src = item.image || '';
        img.alt = item.title || '';
        img.loading = 'lazy';
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', 'הסרת ' + (item.title || 'מוצר') + ' מההשוואה');
        remove.textContent = '✕';
        remove.addEventListener('click', function () {
          write(read().filter(function (entry) { return entry.handle !== item.handle; }));
        });
        chip.appendChild(img);
        chip.appendChild(remove);
        itemsEl.appendChild(chip);
      });
      if (list.length === 1) {
        var hint = document.createElement('span');
        hint.className = 'dz-cmp-hint';
        hint.textContent = 'בחרו עוד מוצר כדי להשוות';
        itemsEl.appendChild(hint);
      }
    }

    function syncToggles() {
      var handles = read().map(function (entry) { return entry.handle; });
      document.querySelectorAll('.dz-cmp-toggle').forEach(function (label) {
        var on = handles.indexOf(label.dataset.handle) !== -1;
        label.classList.toggle('is-on', on);
        var box = label.querySelector('input');
        if (box) box.checked = on;
      });
    }

    function add(handle, host) {
      var list = read();
      if (list.some(function (entry) { return entry.handle === handle; })) return;
      if (list.length >= MAX) {
        alert('אפשר להשוות עד ' + MAX + ' מוצרים. הסירו מוצר כדי להוסיף אחר.');
        syncToggles();
        return;
      }
      var img = host.querySelector('img');
      var titleEl = host.querySelector('.product-title, .product-card__title, h3, h2');
      list.push({
        handle: handle,
        title: host.getAttribute('data-dz-compare-title') || (titleEl ? titleEl.textContent.trim() : handle),
        image: host.getAttribute('data-dz-compare-image') || (img ? img.currentSrc || img.src : '')
      });
      write(list);
    }

    function inject(host) {
      if (host.querySelector('.dz-cmp-toggle')) return;
      var inline = host.getAttribute('data-dz-compare-handle');
      var handle = inline;
      if (!handle) {
        var link = host.querySelector('a[href*="/products/"]');
        if (!link) return;
        handle = handleFromHref(link.getAttribute('href'));
      }
      if (!handle) return;

      var label = document.createElement('label');
      label.className = 'dz-cmp-toggle' + (inline ? ' dz-cmp-toggle--inline' : '');
      label.dataset.handle = handle;
      var box = document.createElement('input');
      box.type = 'checkbox';
      var text = document.createElement('span');
      text.textContent = inline ? 'הוספה להשוואה' : 'השוואה';
      label.appendChild(box);
      label.appendChild(text);

      label.addEventListener('click', function (event) { event.stopPropagation(); });
      box.addEventListener('change', function () {
        if (box.checked) add(handle, host);
        else write(read().filter(function (entry) { return entry.handle !== handle; }));
      });

      if (inline) {
        (host.querySelector('.dz-product-compare__slot') || host).appendChild(label);
      } else {
        host.classList.add('dz-cmp-host');
        host.appendChild(label);
      }
    }

    /* Horizon nests <product-card> around .product-grid__card, so only the
       outermost match of each card gets a toggle. */
    function scan() {
      var nodes = Array.prototype.slice.call(
        document.querySelectorAll('product-card, .product-card, .product-grid__card, .dz-product, [data-dz-compare-handle]')
      );
      nodes
        .filter(function (node) {
          return !nodes.some(function (other) { return other !== node && other.contains(node); });
        })
        .forEach(inject);
      syncToggles();
    }

    /* Clearing on the comparison page leaves nothing to compare, so the shopper
       goes back to the page they came from. Without a page of ours to return to
       (a shared link, a new tab) they land on the catalogue instead. */
    function leaveComparePage() {
      var cameFromStore = document.referrer.indexOf(location.origin + '/') === 0;
      if (cameFromStore && history.length > 1) {
        history.back();
        return;
      }
      var catalog = document.querySelector('#dz-compare-empty .dz-action');
      location.href = catalog ? catalog.href : '/collections/all';
    }

    clearEl.addEventListener('click', function () {
      write([]);
      if (document.getElementById('dz-compare-result')) leaveComparePage();
    });

    /* Back can restore a page from the browser's cache with its old ticks
       still on, and another tab may have changed the selection meanwhile, so
       re-read it whenever a page is shown or the stored list changes. */
    function refresh() { render(); syncToggles(); }
    window.addEventListener('pageshow', refresh);
    window.addEventListener('storage', function (event) { if (event.key === KEY) refresh(); });

    scan();
    render();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["djzone-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var configEl = document.getElementById('dz-search-config');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    /* ---------------------------------------------------------------
       Text normalisation — applied identically to the query and the index.
       DJ is written "די ג׳יי" or "דיג׳יי" in Hebrew; both read as "dj".
       --------------------------------------------------------------- */
    var FINALS = { 'ך': 'כ', 'ם': 'מ', 'ן': 'נ', 'ף': 'פ', 'ץ': 'צ' };
    var DJ_HEBREW = /די\s*ג['׳’]?\s*יי|דיג['׳’]?יי/g;
    function norm(text) {
      return String(text || '').toLowerCase()
        .replace(/[֑-ׇ]/g, '')
        .replace(/[ךםןףץ]/g, function (ch) { return FINALS[ch]; })
        .replace(/[׳״’'"`´]/g, '')
        .replace(/די\s*גיי/g, ' dj ')
        .replace(/[^0-9a-zא-ת]+/g, ' ')
        .trim();
    }
    function words(text) { var n = norm(text); return n ? n.split(' ') : []; }
    function rawWords(text) {
      return String(text || '').split(/[^0-9A-Za-zא-ת׳״’'"]+/).filter(function (w) { return norm(w); });
    }
    function handleize(text) {
      return String(text || '').toLowerCase().replace(/[^a-z0-9א-ת]+/g, '-').replace(/^-+|-+$/g, '');
    }
    var HEBREW = /^[א-ת]+$/;
    function stem(token) {
      if (HEBREW.test(token)) {
        if (token.length > 4 && /(ימ|ות)$/.test(token)) return token.slice(0, -2);
        return token;
      }
      if (token.length > 3 && /s$/.test(token)) return token.slice(0, -1);
      return token;
    }
    function sorted(token) { return token.split('').sort().join(''); }

    /* Optimal-string-alignment distance: insert, delete, replace, swap. */
    function distance(a, b) {
      var m = a.length, n = b.length;
      if (Math.abs(m - n) > 2) return 3;
      var d = [], i, j;
      for (i = 0; i <= m; i++) d[i] = [i];
      for (j = 0; j <= n; j++) d[0][j] = j;
      for (i = 1; i <= m; i++) {
        for (j = 1; j <= n; j++) {
          var cost = a[i - 1] === b[j - 1] ? 0 : 1;
          d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
          if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
            d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
          }
        }
      }
      return d[m][n];
    }

    /* How well one typed word matches one catalogue word, 0–10. */
    function tokenScore(q, t) {
      if (!q || !t) return 0;
      if (t === q) return 10;
      if (t.indexOf(q) === 0) return q.length >= 2 ? 8 : 3;
      if (q.length < 3) return 0;
      if (stem(q) === stem(t)) return 9;
      if (t.indexOf(q) > 0) return 5;
      var cmp = t.length > q.length + 1 ? t.slice(0, q.length) : t;
      var limit = q.length >= 7 ? 2 : 1;
      var d = distance(q, cmp);
      if (d <= limit) return d === 1 ? 6 : 4;
      if (q.length <= 7 && q.length === cmp.length && sorted(q) === sorted(cmp)) return 6;
      return 0;
    }
    function wordScore(q, t) {
      var best = tokenScore(q, t);
      if (HEBREW.test(q) && q.length >= 5 && /^[הובלמשכ]/.test(q)) {
        best = Math.max(best, tokenScore(q.slice(1), t) - 1);
      }
      return best;
    }

    /* Hebrew spellings of the brands, so a shopper can type the name the way
       it sounds. Keyed by the brand handle (vendor, handleized). */
    var BRAND_ALIASES = {
      'pioneer-dj': ['פיוניר', 'פיונר', 'פאיוניר', 'פיונייר', 'alphatheta', 'אלפאתטא', 'אלפא תטא'],
      'mackie': ['מאקי', 'מקי', 'מאקיי', 'מקיי'],
      'rcf': ['ארסיאף', 'אר סי אף'],
      'shure': ['שור'],
      'sennheiser': ['זנהייזר', 'סנהייזר', 'זנהיזר', 'סנהיזר'],
      'audio-technica': ['אודיו טכניקה', 'audiotechnica'],
      'allen-heath': ['אלן הית', 'אלן אנד הית', 'allenheath'],
      'l-acoustics': ['אל אקוסטיקס', 'lacoustics'],
      'blg': ['בי אל גי', 'בלג'],
      'apextone': ['אפקסטון', 'אפקס טון', 'apex'],
      'soundking': ['סאונד קינג', 'סאונדקינג', 'sound king'],
      'roxtone': ['רוקסטון'],
      'seer': ['סיר', 'סייר'],
      'stage-core': ['סטייג קור', 'סטייגקור', 'stagecore'],
      'art-light': ['ארט לייט', 'artlight'],
      'artesia': ['ארטזיה', 'ארטסיה'],
      'haymer-pro': ['היימר', 'הימר', 'hymer'],
      'icm': ['איי סי אם'],
      'swid': ['סוויד', 'סויד'],
      'alctron': ['אלקטרון'],
      'bts': ['בי טי אס'],
      'proaudio': ['פרו אודיו', 'pro audio'],
      'djzone': ['דיגיי זון', 'די גיי זון', 'dj zone']
    };

    /* Everyday words for the product types, in both languages. */
    var SYNONYMS = [
      [['רמקול', 'רמקולימ'], ['speaker', 'speakers', 'בוקסה', 'בוקסות']],
      [['סאב', 'סאבוופר', 'סאבווופר'], ['sub', 'subwoofer', 'סאבוופר', 'באס']],
      [['מיקסר', 'מיקסרימ'], ['mixer', 'mixers', 'מערבל', 'מיקסר']],
      [['מיקרופונ', 'מיקרופונימ'], ['mic', 'mics', 'microphone', 'מיקרופון', 'מייק']],
      [['קונטרולר', 'קונטרולרימ'], ['controller', 'controllers', 'קונטרולר']],
      [['אוזניות'], ['headphones', 'headphone', 'אוזניות']],
      [['כבל', 'כבלימ'], ['cable', 'cables', 'כבל']],
      [['סטנד', 'סטנדימ'], ['stand', 'stands', 'חצובה']],
      [['פנס', 'פנסימ', 'תאורה'], ['light', 'lights', 'lighting', 'פנס', 'תאורה']],
      [['נגנ'], ['player', 'נגן']],
      [['בידורית', 'בידוריות'], ['karaoke', 'קריוקי', 'portable']]
    ];

    /* ---------------------------------------------------------------
       Index
       --------------------------------------------------------------- */
    var index = null;
    var vocab = [];
    var loading = null;
    var CACHE_KEY = 'dz-search-index-v1';

    function brandByHandle(handle) {
      for (var i = 0; i < config.brands.length; i++) if (config.brands[i].h === handle) return config.brands[i];
      return null;
    }

    function build(raw) {
      var seen = {};
      function addVocab(word, display, isAlias) {
        var n = norm(word).replace(/ /g, '');
        if (!n || seen[n]) return;
        seen[n] = true;
        vocab.push({ n: n, w: display, alias: !!isAlias });
      }

      index = raw.products.map(function (p) {
        var brandHandle = handleize(p.v);
        var title = words(p.t);
        var vendor = words(p.v);
        var cols = words((p.c || []).join(' '));
        var type = words(p.y);
        var aliases = (BRAND_ALIASES[brandHandle] || []).map(function (a) { return norm(a).replace(/ /g, ''); });
        var bag = title.concat(cols);
        var syn = [];
        SYNONYMS.forEach(function (rule) {
          var hit = rule[0].some(function (trigger) {
            return bag.some(function (w) { return w === trigger || w.indexOf(trigger) === 0; });
          });
          if (hit) syn = syn.concat(rule[1].map(norm));
        });

        rawWords(p.t).forEach(function (w) { addVocab(w, w, false); });
        rawWords(p.v).forEach(function (w) { addVocab(w, w, false); });
        (BRAND_ALIASES[brandHandle] || []).forEach(function (a) { addVocab(a, p.v, true); });

        return {
          p: p,
          brand: brandHandle,
          fields: [
            { t: title, w: 1 },
            { t: vendor, w: 1.15 },
            { t: aliases, w: 1.1 },
            { t: syn, w: 0.75 },
            { t: cols, w: 0.7 },
            { t: type, w: 0.6 }
          ]
        };
      });
      (config.categories || []).forEach(function (c) { rawWords(c.n).forEach(function (w) { addVocab(w, w, false); }); });
    }

    function load() {
      if (index) return Promise.resolve();
      if (loading) return loading;
      try {
        var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
        if (cached && cached.count === config.count && Date.now() - cached.at < 6 * 3600 * 1000) {
          build(cached.data);
          return Promise.resolve();
        }
      } catch (e) { /* storage unavailable */ }
      loading = fetch(config.indexUrl, { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var start = text.indexOf('{');
          var end = text.lastIndexOf('}');
          var data = JSON.parse(text.slice(start, end + 1));
          build(data);
          try { localStorage.setItem(CACHE_KEY, JSON.stringify({ count: config.count, at: Date.now(), data: data })); } catch (e) { /* quota */ }
        })
        .catch(function () { loading = null; });
      return loading;
    }

    /* ---------------------------------------------------------------
       Matching
       --------------------------------------------------------------- */
    function scoreItem(item, queryWords) {
      var total = 0, matched = 0;
      queryWords.forEach(function (q) {
        var best = 0;
        item.fields.forEach(function (field) {
          field.t.forEach(function (t) {
            var s = wordScore(q, t) * field.w;
            if (s > best) best = s;
          });
        });
        if (best > 0) { total += best; matched++; }
      });
      return { total: total, matched: matched };
    }

    function searchProducts(queryWords) {
      function run(qs, needAll) {
        var out = [];
        index.forEach(function (item) {
          var r = scoreItem(item, qs);
          if (r.matched === 0) return;
          if (needAll && r.matched < qs.length) return;
          var bonus = (norm(item.p.t).indexOf(qs[0]) === 0 ? 1.5 : 0) + (item.p.a ? 0.5 : 0);
          out.push({ item: item, score: r.total + r.matched * 2 + bonus });
        });
        return out.sort(function (a, b) { return b.score - a.score; });
      }
      var results = run(queryWords, true);
      if (!results.length && queryWords.length > 1) results = run([queryWords.join('')], true);
      if (!results.length && queryWords.length > 1) results = run(queryWords, false);
      return results.map(function (r) { return r.item.p; });
    }

    function searchBrands(queryWords) {
      var joined = queryWords.join('');
      return config.brands.map(function (b) {
        var names = [norm(b.n).replace(/ /g, '')].concat(words(b.n))
          .concat((BRAND_ALIASES[b.h] || []).map(function (a) { return norm(a).replace(/ /g, ''); }));
        var best = 0;
        names.forEach(function (n) {
          var s = queryWords.length > 1 ? wordScore(joined, n) : wordScore(queryWords[0], n);
          if (s > best) best = s;
        });
        return { b: b, s: best };
      }).filter(function (r) { return r.s >= 6; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, 4).map(function (r) { return r.b; });
    }

    function searchCategories(queryWords) {
      return (config.categories || []).map(function (c) {
        var names = words(c.n);
        var total = 0, ok = true;
        queryWords.forEach(function (q) {
          var best = 0;
          names.forEach(function (n) { best = Math.max(best, wordScore(q, n)); });
          if (best < 6) ok = false;
          total += best;
        });
        return { c: c, s: ok ? total : 0 };
      }).filter(function (r) { return r.s > 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, 3).map(function (r) { return r.c; });
    }

    /* The words to hand to /search when the engine had to guess: a typo or a
       Hebrew brand spelling is replaced by the catalogue word it matched.
       Hebrew words of three letters or fewer are too short to guess from, so
       they are only replaced by an exact brand alias. */
    function corrected(raw) {
      var originals = rawWords(String(raw || '').replace(DJ_HEBREW, 'DJ'));
      var changed = false;
      var out = originals.map(function (original) {
        var q = norm(original).replace(/ /g, '');
        var best = 0, bestEntry = null;
        vocab.forEach(function (entry) {
          var s = wordScore(q, entry.n);
          if (s > best || (s === best && bestEntry && entry.n.length < bestEntry.n.length)) { best = s; bestEntry = entry; }
        });
        if (!bestEntry || best < 4) return original;
        if (HEBREW.test(q) && q.length <= 3 && !(bestEntry.alias && best === 10)) return original;
        if (bestEntry.alias || best < 8) {
          if (norm(bestEntry.w) !== norm(original)) { changed = true; return bestEntry.w; }
        }
        return original;
      });
      return changed ? out.join(' ') : null;
    }

    function price(cents) {
      return '₪' + (Number(cents) / 100).toLocaleString('he-IL', { maximumFractionDigits: 0 });
    }
    function escapeHtml(text) {
      return String(text == null ? '' : text).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }
    function productUrl(p) { return '/products/' + encodeURIComponent(p.h); }
    function brandUrl(b) { return config.allUrl.replace(/\/$/, '') + '/brand-' + encodeURIComponent(b.h); }
    function searchUrl(q, original) {
      var url = config.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      if (original) url += '&dz_q=' + encodeURIComponent(original);
      return url;
    }

    /* ---------------------------------------------------------------
       Header dropdown
       --------------------------------------------------------------- */
    Array.prototype.forEach.call(document.querySelectorAll('[data-dz-search]'), function (form) {
      var input = form.querySelector('input[name="q"]');
      var panel = form.querySelector('.dz-suggest');
      if (!input || !panel) return;
      var active = -1;
      var timer = null;
      var lastRender = '';

      function options() { return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]')); }
      function setActive(i) {
        var list = options();
        list.forEach(function (el, n) {
          el.classList.toggle('is-active', n === i);
          if (n === i) { el.id = el.id || 'dz-opt-' + n; input.setAttribute('aria-activedescendant', el.id); el.scrollIntoView({ block: 'nearest' }); }
        });
        if (i < 0) input.removeAttribute('aria-activedescendant');
        active = i;
      }
      function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
      function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); setActive(-1); }

      function render() {
        var raw = input.value.trim();
        if (!raw) { close(); lastRender = ''; return; }
        if (!index) {
          panel.innerHTML = '<div class="dz-suggest-loading">מחפשים בקטלוג…</div>';
          open();
          load().then(function () { if (index) render(); });
          return;
        }
        if (raw === lastRender && !panel.hidden) return;
        lastRender = raw;

        var qs = words(raw);
        var fix = corrected(raw);
        var brands = searchBrands(qs);
        var cats = searchCategories(qs);
        /* Rank by the corrected words when the engine had to guess, so "רמקל"
           lists speakers before speaker cables. */
        var products = searchProducts(fix ? words(fix) : qs).slice(0, 6);
        if (!products.length && fix) products = searchProducts(qs).slice(0, 6);
        var html = '';

        if (fix && products.length) html += '<p class="dz-suggest-note">מציג תוצאות עבור <b>' + escapeHtml(fix) + '</b></p>';
        if (brands.length) {
          html += '<p class="dz-suggest-label">מותגים</p><div class="dz-suggest-brands">';
          brands.forEach(function (b) {
            html += '<a class="dz-suggest-brand" role="option" href="' + brandUrl(b) + '">' +
              (b.l ? '<img src="' + escapeHtml(b.l) + '" alt="" loading="lazy">' : '') + escapeHtml(b.n) + '</a>';
          });
          html += '</div>';
        }
        if (cats.length) {
          html += '<p class="dz-suggest-label">קטגוריות</p>';
          cats.forEach(function (c) {
            html += '<a class="dz-suggest-cat" role="option" href="' + escapeHtml(c.u) + '"><span>' + escapeHtml(c.n) + '</span>' +
              (c.p ? '<small>' + escapeHtml(c.p) + '</small>' : '') + '</a>';
          });
        }
        if (products.length) {
          html += '<p class="dz-suggest-label">מוצרים</p>';
          products.forEach(function (p) {
            html += '<a class="dz-suggest-product" role="option" href="' + productUrl(p) + '">' +
              '<img src="' + escapeHtml(p.i || '') + '" alt="" loading="lazy" width="54" height="54">' +
              '<span><b>' + escapeHtml(p.t) + '</b><small>' + escapeHtml(p.v) + '</small></span>' +
              '<i>' + (p.a ? price(p.p) : 'אזל') + '</i></a>';
          });
          html += '<a class="dz-suggest-all" role="option" href="' + searchUrl(fix || raw, fix ? raw : '') + '">לכל התוצאות עבור ״' + escapeHtml(fix || raw) + '״ ←</a>';
        }
        if (!brands.length && !cats.length && !products.length) {
          html = '<div class="dz-suggest-empty">לא מצאנו התאמה ל־״' + escapeHtml(raw) + '״.<br>נסו שם של מותג, דגם או סוג מוצר — למשל ״רמקול״ או ״Pioneer״.</div>';
        }
        panel.innerHTML = html;
        open();
        setActive(-1);
      }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(render, 70);
      });
      input.addEventListener('focus', function () {
        load();
        if (input.value.trim()) { lastRender = ''; render(); }
      });
      input.addEventListener('keydown', function (event) {
        var list = options();
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (panel.hidden) render();
          setActive(list.length ? (active + 1) % list.length : -1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(list.length ? (active <= 0 ? list.length - 1 : active - 1) : -1);
        } else if (event.key === 'Escape') {
          if (!panel.hidden) { event.preventDefault(); close(); }
        } else if (event.key === 'Enter' && active >= 0 && list[active]) {
          event.preventDefault();
          window.location.href = list[active].href;
        }
      });
      form.addEventListener('submit', function (event) {
        var raw = input.value.trim();
        if (!raw || !index) return;
        var fix = corrected(raw);
        if (fix) {
          event.preventDefault();
          window.location.href = searchUrl(fix, raw);
        }
      });
      document.addEventListener('click', function (event) { if (!form.contains(event.target)) close(); });
      panel.addEventListener('mousemove', function (event) {
        var option = event.target.closest('[role="option"]');
        if (option) setActive(options().indexOf(option));
      });
    });

    /* ---------------------------------------------------------------
       /search: say which words were searched, and when Shopify's exact search
       finds nothing, offer the engine's closest matches instead.
       --------------------------------------------------------------- */
    if (window.location.pathname.replace(/\/$/, '') === config.searchUrl.replace(/\/$/, '')) {
      var params = new URLSearchParams(window.location.search);
      var q = (params.get('q') || '').trim();
      var original = (params.get('dz_q') || '').trim();
      var main = document.getElementById('MainContent');
      if (main && q) {
        if (original && norm(original) !== norm(q)) {
          var note = document.createElement('p');
          note.className = 'dz-search-note';
          note.innerHTML = 'מציג תוצאות עבור <b>' + escapeHtml(q) + '</b>. חיפשתם <a href="' + escapeHtml(config.searchUrl + '?q=' + encodeURIComponent(original) + '&type=product') + '">' + escapeHtml(original) + '</a>.';
          main.insertBefore(note, main.firstChild);
        }
        var found = main.querySelectorAll('a[href*="/products/"]').length;
        if (!found) {
          load().then(function () {
            if (!index) return;
            var results = searchProducts(words(q)).slice(0, 12);
            if (!results.length) return;
            var fix = corrected(q);
            var box = document.createElement('section');
            box.className = 'dz-search-fallback';
            var html = '<h2>' + (fix ? 'אולי התכוונתם ל־״' + escapeHtml(fix) + '״?' : 'מוצרים קרובים לחיפוש שלכם') + '</h2><div class="dz-search-fallback-grid">';
            results.forEach(function (p) {
              html += '<a class="dz-search-card" href="' + productUrl(p) + '" data-dz-compare-handle="' + escapeHtml(p.h) + '">' +
                '<img src="' + escapeHtml(p.i || '') + '" alt="" loading="lazy">' +
                '<b>' + escapeHtml(p.t) + '</b><small>' + escapeHtml(p.v) + '</small><i>' + (p.a ? price(p.p) : 'אזל מהמלאי') + '</i></a>';
            });
            box.innerHTML = html + '</div>';
            main.appendChild(box);
          });
        }
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
